<template>
  <div class="managerinvoice">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class=""><router-link to="/home/invoice">发票列表</router-link></li>
          <li class=""><router-link to="/home/getinvoice">发票索取</router-link></li>
          <li class="active"><a href="javascript:;">发票信息管理</a></li>
        </ul>
      </nav>
    </div>
    <p class="tishi">
      <span @click="manager('')">添加发票信息</span>
    </p>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="detail">
      <el-table-column
        prop="org_name"
        label="公司名称"
        width="190"
        align="center">
      </el-table-column>
      <el-table-column
        prop="org_taxpayer_reg_number"
        label="纳税人识别号"
        width="180"
        align="center">
      </el-table-column>
      <el-table-column
        prop="per_name"
        label="收票人姓名"
        align="center"
        width="90"
        >
      </el-table-column>
      <el-table-column
        label="收票人地址"
        align="center"
        prop="per_address"
        >
      </el-table-column>
      <el-table-column
        label="设为默认"
        align="center"
        width="80"
        >
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.is_default" @change="defaultInvoice(scope.row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
        >
        <template slot-scope="scope">
          <span class="tool"><a href="javascript:;" @click="manager(scope.row)">修改</a>|<a href="javascript:;"  @click="del(scope.row.invoice_number)">删除</a></span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        background
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :append-to-body='true' custom-class="invoicemanagerdialog">
      <invoiceItem :model="item" :Isprice="isprice" @updatebtn="updatebtn" @addInvoiceSuccess="invoiceAdd" :btntext="btntext" :btndisable="disable" @alertout="alertout"></invoiceItem>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
import invoiceItem from '@/components/invoice/invoiceItem.vue'
export default {
  name: 'Invoice',
  components: {
    'invoiceItem': invoiceItem
  },
  created () {
    this.invoiceList()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      total: 0,
      title: '发票信息',
      dialogFormVisible: false,
      isprice: false,
      btntext: '确定',
      disable: 'disable',
      item: {

      },
      tableData: []
    }
  },
  methods: {
    manager (p) {
      if (p) {
        /* 这里要从后台根据id获取单个发票的数据 */
        this.item = p
        this.disable = 'btn'
      } else {
        this.item = {}
        this.disable = 'btn'
      }
      this.dialogFormVisible = true
    },
    del (id) {
      let aid = {id: id}
      this.sapost('/dmc/account/deleteInvoice', aid, r => {
        let { retMsg, retCode } = r.data
        if (retCode === '0') {
          this.$message.success(retMsg)
          this.invoiceList()
          // this.$alert('<p class="alert"><i class="el-icon-circle-check"></i>删除成功！</p>', '提示', {
          //   dangerouslyUseHTMLString: true,
          //   customClass: 'invoicealert'
          // })
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    alertout () {
      this.$alert('<p class="alert"><i class="el-icon-circle-check"></i>操作成功', '提示', {
        dangerouslyUseHTMLString: true,
        customClass: 'invoicealert',
        callback: () => {
          this.dialogFormVisible = false
        }
      })
    },
    invoiceAdd(invoice) {
      this.dialogFormVisible = false
      this.invoiceList()
    },
    updatebtn (val) {
      this.disable = val
    },
    invoiceList() {
      let queryParam = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.sapost('/dmc/account/invoice', queryParam, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          pager.list.forEach(item => {
            if (item.is_default === 'y') {
              item.is_default = true
            } else {
              item.is_default = false
            }
          })
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.invoiceList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.invoiceList()
    },
    defaultInvoice(row) {
      this.tableData.forEach(item => {
        if (item.invoice_number !== row.invoice_number) {
          item.is_default = false
        } else {
          let queryParam = {id: row.invoice_number}
          this.sapost('/dmc/account/setInvoiceDefault', queryParam, r => {
            let { retMsg, retCode } = r.data
            if (retCode === '0') {
              this.$message.success(retMsg)
            } else {
              if (retMsg === '用户未登录！') {
                eventBus.$emit('logout')
              }
              this.$message.warning(retMsg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.managerinvoice{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 550px;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 65px;
          a{
            color:#b4b8bb;
          }
        }
        li.active {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
        li:hover {
          border-bottom: 2px solid #f97575;
          a{
            color:#f97575;
          }
        }
      }
    }
  }
  .tishi{
    overflow: hidden;
    margin-top: 37px;
    line-height: 40px;
    height: 40px;
    border: 1px solid #efefef;
    font-size: 12px;
    padding-left: 15px;
    span{
      margin-left: 10px;
      cursor: pointer;
      color: #f01400;
    }
  }
  .detail{
    .el-checkbox__inner{
      border-radius: 50%;
    }
  }
  .el-table{
    border: 1px solid #efefef;
    th{
      background-color:#f4f3f3;
      border-color: #f4f3f3;
      padding: 9px 0;
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
  .el-table__body{
    .tool {
      color: red;
      a{
        font-size: 14px;
        color: red;
        padding: 0 3px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/managerinvoice.vue